<template>
  <transition name="slide">
    <div
      v-if="visible"
      :style="{ backgroundColor: color }"
      class="snackbar"
      @click="close"
    >
      {{ message }}
    </div>
  </transition>
</template>
  
  <script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      color: "",
      timeout: 3000, // Tempo padrão
    };
  },
  methods: {
    open() {
      this.visible = true;
      // Fechar automaticamente após o timeout
      setTimeout(() => {
        this.close();
      }, this.timeout);
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
  
  <style scoped>
.snackbar {
  position: fixed;
  bottom: 20px; /* Ajuste a posição conforme necessário */
  right: 20px; /* Ajuste a posição conforme necessário */
  padding: 16px;
  border-radius: 4px;
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000; /* Garante que o Snackbar fique acima de outros elementos */
  cursor: pointer; /* Opção para fechar ao clicar */
  transition: all 0.5s ease; /* Transição suave para a animação */
}
.slide-enter-active {
  animation: slide-in 0.5s forwards; /* Animação de entrada */
}
.slide-leave-active {
  animation: slide-out 0.5s forwards; /* Animação de saída */
}

@keyframes slide-in {
  from {
    transform: translateX(100%); /* Começa fora da tela à direita */
    opacity: 0; /* Inicia invisível */
  }
  to {
    transform: translateX(0); /* Move para a posição original */
    opacity: 1; /* Torna visível */
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0); /* Começa na posição original */
    opacity: 1; /* Inicia visível */
  }
  to {
    transform: translateX(100%); /* Move para fora da tela à direita */
    opacity: 0; /* Torna invisível */
  }
}
</style>
  